import { createAction } from 'redux-act';

import * as playables from '../../core/playables';

export const fetchPlayables = createAction(
  'get all playables',
);

export const fetchPlayablesSuccess = createAction(
  'get all playables success',
  (allplayables) => allplayables
);

export const fetchPlayablesFail = createAction(
  'get all playables fail',
  (error) => error
);

export const addPlayable = createAction(
  'add new playable',
);

export const addPlayableSuccess = createAction(
  'add new playable success',
  (allplayables) => allplayables
);

export const addPlayableFail = createAction(
  'add new playable fail',
  (error) => error
);

export const updatePlayable = createAction(
  'update playable'
);
export const updatePlayableSuccess = createAction(
  'update playable success'
);
export const updatePlayableFail = createAction(
  'update playable fail',
  (error) => error
);

export const openUpdatePlayable = createAction(
  'open update playable modal'
);

export const closeUpdatePlayable = createAction(
  'close update playable modal'
);

export const reducer = {
  [fetchPlayables]: (state, payload) =>
    playables.fetchPlayables(state, payload),
  [fetchPlayablesSuccess]: (state, payload) =>
    playables.fetchPlayablesSuccess(state, payload),

  [addPlayableSuccess]: (state, payload) =>
    playables.addPlayableSuccess(state, payload),
  [addPlayableFail]: (state, payload) =>
    playables.addPlayableFail(state, payload),

  [updatePlayableSuccess]: (state, payload) =>
    playables.updatePlayableSuccess(state, payload),
  [updatePlayableFail]: (state, payload) =>
    playables.updatePlayableFail(state, payload),

  [openUpdatePlayable]: (state, payload) =>
    playables.openUpdatePlayable(state, payload),
  [closeUpdatePlayable]: (state, payload) =>
    playables.closeUpdatePlayable(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/playables.module.js
 **/